import { useState, useEffect, useMemo } from 'react';

var getNow = function () { return Date.now(); };
var handleMoreThanClick = function (element, handleAction, handleProgressChange, options) {
    if (handleAction === void 0) { handleAction = function () { }; }
    if (handleProgressChange === void 0) { handleProgressChange = function () { }; }
    if (options === void 0) { options = {}; }
    var _a = options.firstSingleClickProgress, firstSingleClickProgress = _a === void 0 ? 0.3 : _a, _b = options.minimumHoldDuration, minimumHoldDuration = _b === void 0 ? 300 : _b, _c = options.holdDurationToAction, holdDurationToAction = _c === void 0 ? 800 : _c, _d = options.decayDuration, decayDuration = _d === void 0 ? 1000 : _d, _e = options.decayAfterActionDuration, decayAfterActionDuration = _e === void 0 ? 200 : _e, _f = options.doubleClickMaximumInterval, doubleClickMaximumInterval = _f === void 0 ? 500 : _f;
    var progress = 0;
    var lastPressAction = null;
    var clickedOnceAt = null;
    var loopId = null;
    var isActionPerformed = false;
    var isDisabled = function () {
        return element instanceof HTMLButtonElement && element.disabled;
    };
    var loop = function () {
        var now = getNow();
        if (progress === 0 && (lastPressAction === null || lastPressAction === void 0 ? void 0 : lastPressAction.type) !== 'down') {
            stopLoop();
            return;
        }
        if ((lastPressAction === null || lastPressAction === void 0 ? void 0 : lastPressAction.type) === 'down') {
            setProgress(lastPressAction.progress +
                (now - lastPressAction.time) / holdDurationToAction);
        }
        else if (lastPressAction !== null) {
            setProgress(lastPressAction.progress -
                (now - lastPressAction.time) /
                    (isActionPerformed ? decayAfterActionDuration : decayDuration));
        }
        loopId = requestAnimationFrame(loop);
    };
    var startLoopIfIdle = function () {
        if (loopId !== null) {
            return;
        }
        loop();
    };
    var stopLoop = function () {
        if (loopId !== null) {
            cancelAnimationFrame(loopId);
            loopId = null;
        }
    };
    var setProgress = function (newProgress) {
        var newProgressClamped = Math.min(1, Math.max(0, newProgress));
        if (newProgressClamped !== progress) {
            progress = newProgressClamped;
            if (progress === 0) {
                clickedOnceAt = null;
                isActionPerformed = false;
            }
            handleProgressChange(progress);
        }
    };
    var handleBeforeAction = function (type) {
        isActionPerformed = true;
        handleAction(type);
    };
    var handleClick = function () {
        if (progress * holdDurationToAction < minimumHoldDuration) {
            setProgress(firstSingleClickProgress);
        }
        if (clickedOnceAt !== null &&
            clickedOnceAt >= getNow() - doubleClickMaximumInterval) {
            handleBeforeAction('double-click');
        }
        else {
            clickedOnceAt = getNow();
        }
        lastPressAction = {
            type: 'click',
            time: getNow(),
            progress: progress,
        };
        startLoopIfIdle();
    };
    var handlePointerDown = function (event) {
        if (event.button !== 0 || isDisabled()) {
            return;
        }
        lastPressAction = {
            type: 'down',
            time: getNow(),
            progress: progress,
        };
        startLoopIfIdle();
    };
    var handlePointerUp = function (event) {
        if ((lastPressAction === null || lastPressAction === void 0 ? void 0 : lastPressAction.type) !== 'down' || event.button !== 0) {
            return;
        }
        lastPressAction = {
            type: 'up',
            time: getNow(),
            progress: progress,
        };
        if (progress === 1) {
            handleBeforeAction('long-press');
        }
        startLoopIfIdle();
    };
    var handlePointerLeave = function () {
        if ((lastPressAction === null || lastPressAction === void 0 ? void 0 : lastPressAction.type) !== 'down') {
            return;
        }
        lastPressAction = {
            type: 'leave',
            time: getNow(),
            progress: progress,
        };
        startLoopIfIdle();
    };
    element.addEventListener('click', handleClick);
    element.addEventListener('pointerdown', handlePointerDown);
    element.addEventListener('pointerup', handlePointerUp);
    element.addEventListener('pointerleave', handlePointerLeave);
    var destroy = function () {
        element.removeEventListener('click', handleClick);
        element.removeEventListener('pointerdown', handlePointerDown);
        element.removeEventListener('pointerup', handlePointerUp);
        element.removeEventListener('pointerleave', handlePointerLeave);
        stopLoop();
    };
    return {
        destroy: destroy,
        isDisabled: isDisabled,
        isPressed: function () { return (lastPressAction === null || lastPressAction === void 0 ? void 0 : lastPressAction.type) === 'down'; },
        progress: function () { return progress; },
    };
};

var useMoreThanClick = function (ref, actionHandler, options) {
    var _a = useState(0), progress = _a[0], setProgress = _a[1];
    useEffect(function () {
        if (ref.current === null) {
            return;
        }
        var handler = handleMoreThanClick(ref.current, actionHandler, function (progress) {
            setProgress(progress);
        }, options);
        return function () {
            handler.destroy();
        };
    }, [ref, actionHandler, options]);
    return useMemo(function () { return ({ progress: progress }); }, [progress]);
};

export { useMoreThanClick };
//# sourceMappingURL=index.es.js.map
